import * as RDialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";

export interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  overlayClassName?: string;
  contentClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  /** Lets a caller consume Esc itself (e.g. close an inner pane first). */
  onEscapeKeyDown?: (event: KeyboardEvent) => void;
}

export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  overlayClassName,
  contentClassName,
  titleClassName,
  descriptionClassName,
  onEscapeKeyDown,
}: DialogProps): JSX.Element {
  return (
    <RDialog.Root open={open} onOpenChange={onOpenChange}>
      <RDialog.Portal>
        <RDialog.Overlay
          className={overlayClassName ?? "ds-dialog__overlay"}
        />
        <RDialog.Content
          className={contentClassName ?? "ds-dialog__content"}
          {...(onEscapeKeyDown ? { onEscapeKeyDown } : {})}
        >
          <RDialog.Title className={titleClassName}>{title}</RDialog.Title>
          {description !== undefined && (
            <RDialog.Description className={descriptionClassName}>
              {description}
            </RDialog.Description>
          )}
          {children}
        </RDialog.Content>
      </RDialog.Portal>
    </RDialog.Root>
  );
}

export const DialogClose = RDialog.Close;
export const DialogTrigger = RDialog.Trigger;
